import { withAuthenticationRequired } from '@auth0/auth0-react';
import React from 'react';
import ApiCredentials from './components/ApiCredentials';
import ApiUsage from './components/ApiUsage';
import ExamplesSection from './components/ExamplesSection';
import PageLayout from './components/PageLayout';
import TutorialSection from './components/TutorialSection';
import { useAccessToken } from './hooks/useAccessToken';

const DevelopersPage: React.FC = () => {
  const { token, expiresAt } = useAccessToken();

  return (
    <PageLayout>
      <ApiCredentials token={token} expiresAt={expiresAt} />
      <ApiUsage />
      <ExamplesSection token={token} />
      <TutorialSection />
    </PageLayout>
  );
};

// Wrap the component with withAuthenticationRequired
export default withAuthenticationRequired(DevelopersPage, {
  onRedirecting: () => (
    <PageLayout>
      <div>Loading...</div>
    </PageLayout>
  ),
});
